import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageLabel from "./LanguageLabel";

export default function LanguageToggle({ size = "small" }) {
  const { i18n } = useTranslation();
  const language = i18n.language?.split("-")[0];
  const value = ["en", "de", "ar"].includes(language) ? language : "en";

  const handleChange = (_e, next) => {
    if (!next) return; // ignore deselect
    if (next !== value) {
      i18n.changeLanguage(next);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size={size}
      aria-label="language switcher"
    >
      <ToggleButton value="en" aria-label="English">
        <LanguageLabel language="en" />
      </ToggleButton>
      <ToggleButton value="de" aria-label="Deutsch">
        <LanguageLabel language="de" />
      </ToggleButton>
      <ToggleButton value="ar" aria-label="Arabic">
        <LanguageLabel language="ar" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
